import { useUserIdentitySync } from '../hooks/useUserIdentitySync';

/**
 * Provider component that handles user identity synchronization
 * Fetches user identity after authentication and updates global store
 * Should be placed inside AuthProvider but outside main app content
 *
 * @component
 * @param props Component props
 * @param props.children Child components to render
 * @returns JSX element
 *
 * @example
 * ```tsx
 * <AuthProvider>
 *   <UserIdentityProvider>
 *     <App />
 *   </UserIdentityProvider>
 * </AuthProvider>
 * ```
 */
export const UserIdentityProvider = ({ children }: { children: React.ReactNode }) => {
  // This hook handles all the user identity synchronization logic
  useUserIdentitySync();

  return <>{children}</>;
};
